import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import ContactsCreateComponents from "../../components/ContactsComponents/ContactsCreateComponents";
import NavegacionFarms from "../../components/NavigableComponents/NavigableFarms";
export default function CreateContacts() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="col-12 col-lg-11 mx-auto">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Farms/'}>{t("Global_Label_Text_Farms")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Contacts/'}>{t("Global_Label_Text_Contacts")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/CreateContacts/'}>{t("Global_Label_Text_Add")}</Link></li>
                                </ol>
                            </nav>
                            <NavegacionFarms />
                        </div>
                    </div>
                </div>

                <div>
                    <ContactsCreateComponents />
                </div>

                <br />
            </div > : ""}
        </div>
    );

}
